export interface BurgerIngredient {
  id: string;
  name: string;
  nameMn: string;
  price: number;
  category: 'bread' | 'meat' | 'vegetable' | 'sauce' | 'cheese';
}

export interface BurgerOrder {
  id?: string;
  ingredients: BurgerIngredient[];
  totalPrice: number;
  customerEmail: string;
  customerName: string;
  customerPhone: string;
  status: 'pending' | 'confirmed' | 'preparing' | 'ready' | 'delivered';
  orderDate: Date;
  deliveryAddress: string;
}

export interface OrderStatus {
  pending: string;
  confirmed: string;
  preparing: string;
  ready: string;
  delivered: string;
}

export const ORDER_STATUS_MN: OrderStatus = {
  pending: 'Хүлээгдэж байна',
  confirmed: 'Баталгаажсан',
  preparing: 'Бэлтгэж байна',
  ready: 'Бэлэн болсон',
  delivered: 'Хүргэгдсэн'
};
